import { Modal } from "@chakra-ui/react";
import { gql } from "__generated__/gql";
import {
  CONTENT_FULL_HEIGHT,
  CONTENT_FULL_WIDTH,
  NAVBAR_HEIGHT,
  SIDEBAR_WIDTH,
} from "components/Layout/constants";
import BrandName from "components/Shared/BrandName";
import ModalBlurOverlay from "components/Shared/ModalBlurOverlay";
import { useBrandQuery } from "utils/apollo/hooks/brand";
import { useCurrentBrandId } from "utils/currentUserHooks";
import { EMAIL_POLL_INTERVAL } from "components/Core/EmailInbox/Table";
import BrandEmailAddressesModalContent from "./BrandEmailAddressesModalContent";

const query = gql(/* GraphQL */ `
  query BrandEmailInboxEmptyState($brandId: UUID!) {
    receivedEmailMessages(
      filter: { receivedEmailMessageBrand: { brandId: { equalTo: $brandId } } }
    ) {
      totalCount
    }
  }
`);

export default function EmptyStateModal() {
  const brandId = useCurrentBrandId();

  const { data, loading } = useBrandQuery(query, {
    variables: brandId ? { brandId } : undefined,
    skip: !brandId,
    fetchPolicy: "network-only",
    pollInterval: EMAIL_POLL_INTERVAL,
  });

  const hasNoBrandEmails = data?.receivedEmailMessages?.totalCount === 0;

  return (
    <Modal
      isOpen={!loading && hasNoBrandEmails}
      onClose={() => {}}
      size="lg"
      returnFocusOnClose={false}
      trapFocus={false}
      useInert={false}
    >
      <ModalBlurOverlay
        top={NAVBAR_HEIGHT}
        left={SIDEBAR_WIDTH}
        height={CONTENT_FULL_HEIGHT}
        width={CONTENT_FULL_WIDTH}
      />

      <BrandEmailAddressesModalContent
        hasCloseButton={false}
        heading={
          <>
            <BrandName fallback="This account" /> doesn’t have any emails yet
          </>
        }
        containerProps={{
          ml: SIDEBAR_WIDTH,
          mt: NAVBAR_HEIGHT,
          width: CONTENT_FULL_WIDTH,
          height: CONTENT_FULL_HEIGHT,
        }}
      />
    </Modal>
  );
}
